"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderRoStatuses = exports.OrderRoStatusLabels = exports.OperationsSubscriptionStatusLabels = exports.OperationsSubscriptionStatus = exports.OperationsSubscriptionStatuses = exports.OperationsDocRefEntity = exports.OperationsDocRefEntityLabels = exports.OperationsDocRefEntities = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OperationsDocRefEntities = ['operations-subscription', 'operations-order', 'operations-order-ro'];
exports.OperationsDocRefEntityLabels = {
    'operations-subscription': 'Subscription',
    'operations-order': 'Order',
    'operations-order-ro': 'Roll-Off Order',
};
exports.OperationsDocRefEntity = typebox_1.Type.Union(exports.OperationsDocRefEntities.map((value) => typebox_1.Type.Literal(value)));
exports.OperationsSubscriptionStatuses = ['ACTIVE', 'COMPLETE', 'DELETE'];
exports.OperationsSubscriptionStatus = typebox_1.Type.Union(exports.OperationsSubscriptionStatuses.map((type) => typebox_1.Type.Literal(type)));
exports.OperationsSubscriptionStatusLabels = {
    COMPLETE: {
        wayste: 'Complete',
    },
    DELETE: {
        wayste: 'Delete',
    },
    ACTIVE: {
        wayste: 'Active',
    },
};
// Roll-off order labels, keyed on the generated `ModelOrderRoStatus` — operations-client is the
// single source of truth for the status set.
exports.OrderRoStatusLabels = {
    NEEDS_REVIEW: { wayste: 'Needs Review' },
    UNASSIGNED_DELIVERY: { wayste: 'Unassigned Delivery' },
    ASSIGNED_DELIVERY: { wayste: 'Assigned Delivery' },
    ENROUTE_DELIVERY: { wayste: 'Enroute Delivery' },
    DELIVERED: { wayste: 'Delivered' },
    UNASSIGNED_PICKUP: { wayste: 'Unassigned Pickup' },
    ASSIGNED_PICKUP: { wayste: 'Assigned Pickup' },
    ENROUTE_PICKUP: { wayste: 'Enroute Pickup' },
    PICKED_UP: { wayste: 'Picked Up' },
    UNASSIGNED_DUMP: { wayste: 'Unassigned Dump' },
    ASSIGNED_DUMP: { wayste: 'Assigned Dump' },
    ENTER_TICKET: { wayste: 'Enter Ticket' },
    DUMPED: { wayste: 'Dumped' },
    COMPLETED: { wayste: 'Completed' },
    CANCELLED: { wayste: 'Canceled' },
};
exports.OrderRoStatuses = Object.keys(exports.OrderRoStatusLabels);
//# sourceMappingURL=enums.js.map